import Layout from "@/components/Layout";
import { PageHero } from "@/hooks/usePageContent";
import { Link } from "react-router-dom";
import { QrCode, MapPin, ShoppingBag, FileText } from "lucide-react";

export default function MobileGallery() {
  return (
    <Layout>
      <PageHero slug="mobile-gallery" />
      <section className="bg-black pt-24 pb-24">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12">
          <h1 className="text-grunge text-5xl md:text-7xl text-[#F5F2EB] leading-[0.95] mb-8">
            THE GALLERY<br/>WALKS WITH YOU.
          </h1>
          <p className="font-body text-xl text-[#A3A3A3] max-w-2xl mb-16 leading-relaxed">
            Every Simple Truth has a place in town. Coffee shops. Barbershops. Booths. Public corners. Each one displayed on the wall, ready to be scanned, read, and carried home — without ever opening a website first.
          </p>

          <div className="grid md:grid-cols-4 gap-8 mb-20">
            {[
              { i: <MapPin size={22}/>, t: "Spot a Truth", d: "On a wall. In a window. Wherever a piece has found its place." },
              { i: <QrCode size={22}/>, t: "Scan the Code", d: "Open your camera and scan. No app required." },
              { i: <FileText size={22}/>, t: "Read the Story", d: "The piece, its meaning, and what it’s pointing you toward." },
              { i: <ShoppingBag size={22}/>, t: "Take It Home", d: "Buy on the spot. Digital, print, or canvas — shipped to your door." },
            ].map((s, i) => (
              <div key={i} className="border-l border-[#B8915A]/30 pl-5">
                <div className="text-[#B8915A] mb-3">{s.i}</div>
                <div className="font-ui text-[10px] tracking-[0.32em] text-[#B8915A] uppercase mb-2">Step {String(i+1).padStart(2,"0")}</div>
                <div className="text-grunge text-xl text-[#F5F2EB] mb-2">{s.t}</div>
                <p className="font-body text-[#A3A3A3]">{s.d}</p>
              </div>
            ))}
          </div>

          <div className="border border-white/10 bg-[#0a0a0a] p-10 md:p-16 text-center" data-testid="mobile-host-cta">
            <div className="font-ui text-[10px] tracking-[0.32em] text-[#C9A055] uppercase mb-3">Are You A Business?</div>
            <h3 className="text-grunge text-3xl md:text-4xl text-[#F5F2EB] mb-4">Want Simple Truths on your wall?</h3>
            <p className="font-body text-[#A3A3A3] max-w-2xl mx-auto mb-6">
              Coffee shops, barbershops, boutiques, waiting rooms, market booths, offices, and public spaces can apply to become a Simple Truths Host.
              We provide the framed artwork and QR display signage. You display the truth. When someone scans from your location and makes a purchase, you earn an agreed commission.
            </p>
            <Link to="/partner-apply" className="btn-gold" data-testid="mobile-become-host">Become A Host →</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
